import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
// import EditUserForm from 'components/Admin/User/EditUserForm';
import ProfileForm from "components/Profile/Profile";
import actions from "actions";
import constants from "constants";
import validator from "services/validator";
import inputFormatter from "services/userInputFormatter";

const { ERROR_TYPE_USER_UPDATE_ERROR, ADMIN_UPDATE_USER_SAGA } = constants;

const { loadEditUser, adminUpdateUserSaga, addValidateError, cleanErrors } =
  actions;

class EditUserSponsor extends Component {
  static propTypes = {
    createUser: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj,
  };

  constructor(props) {
    super(props);
    const user = this.props.user;
    this.state = {
      user: {
        first_name: "",
        last_name: "",
        email: "",
        user_type: "sponsor",
        phone: null,
        company_name: "",
        imc: "",
        gender: "",
        registration: "",
        county: "",
        practice_name: "",
        show_id_number: false,
        hospital: "",
        role: "",
        title: "",
        email_confirmed: "",
        ipna_member: false,
        accreditation: false,
        county: "",
        branch: "",
        sponsor_type: "",
        ...user,
      },
    };
  }

  componentWillReceiveProps(props) {
    if (!_.isEqual(this.props.user, props.user))
      this.setState({
        user: {
          ...this.state.user,
          ...props.user,
        },
      });
  }

  componentWillMount() {
    this.props.cleanErrors();
    this.props.loadEditUser(this.props.params.id);
  }

  onFieldChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const userData = {
      ...this.state.user,
      ...{
        [e.target.name]: input,
      },
    };

    this.setState({ user: userData });
  };

  onIpnaChange = (event) => {
    if (!(event.target.value == "true")) {
      const userData = {
        ...this.state.user,
        ...{
          ipna_member: event.target.value == "true",
          branch: null,
        },
      };
      this.setState({ user: userData });
    } else {
      const userData = {
        ...this.state.user,
        ...{
          ipna_member: event.target.value == "true",
        },
      };
      this.setState({ user: userData });
    }
  };

  onShowIdNumberChange = (event) => {
    const userData = {
      ...this.state.user,
      ...{
        show_id_number: event.target.value == "true",
      },
    };
    this.setState({ user: userData });
  };

  // onRepresentativeChange = (event) => {
  //   const userData = {
  //     ...this.state.user,
  //     ...{
  //       is_representative: event.target.value == 'true',
  //     }
  //   }
  //   this.setState({ user: userData })
  // }

  onAccreditaionChange = (event) => {
    if (event.target.value == "true") {
      const userData = {
        ...this.state.user,
        ...{
          accreditation: event.target.value == "true",
          country: null,
        },
      };
      this.setState({ user: userData });
    } else {
      const userData = {
        ...this.state.user,
        ...{
          accreditation: event.target.value == "true",
        },
      };
      this.setState({ user: userData });
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.props.adminUpdateUserSponsor(this.state.user);
  };

  irishRoleFields = () => {
    switch (this.state.user.user_type) {
      case "sponsor":
        return [];
      default:
        return [];
    }
  };

  internationRoleFields = () => {
    switch (this.state.user.user_type) {
      case "sponsor":
        return [];
      default:
        return [];
    }
  };

  onCountryChange = (status) => {
    const userData = {
      ...this.state.user,
      ...{
        country: status.value,
      },
    };

    this.setState({ user: userData });
  };

  onBranchChange = (status) => {
    const userData = {
      ...this.state.user,
      ...{
        branch: status.value,
      },
    };

    this.setState({ user: userData });
  };

  onFieldChange = (e) => {
    const userData = {
      ...this.state.user,
      ...{
        [e.target.name]: e.target.value,
      },
    };

    this.setState({ user: userData }); //, this.validateUser);
  };

  onCountyChange = (e) => {
    const userData = {
      ...this.state.user,
      ...{ county: e.value },
    };
    this.setState({ user: userData });
  };

  onRoleChange = (e) => {
    const userData = {
      ...this.state.user,
      ...{ user_type: e.target.value },
    };
    this.setState({ user: userData });
  };

  render() {
    const { errors, errorsFrontend } = this.props;
    const outErrors = Object.keys(errorsFrontend || {}).length
      ? errorsFrontend
      : errors;
    return (
      <main className="site--width clearfix-c">
        <h2 className="main_title">Client #{this.state.user.id}</h2>
        <ProfileForm
          user={this.state.user}
          onFieldChange={this.onFieldChange}
          onSubmit={this.onSubmit}
          errors={outErrors || {}}
          onRoleChange={this.onRoleChange}
          onCountyChange={this.onCountyChange}
          irishRoleFields={this.irishRoleFields()}
          internationRoleFields={this.internationRoleFields()}
          onAccreditaionChange={this.onAccreditaionChange}
          onWiMinChange={this.onWiMinChange}
          onBranchChange={this.onBranchChange}
          onCountryChange={this.onCountryChange}
          is_admin={true}
          isSponsorForm
          onShowIdNumberChange={this.onShowIdNumberChange}
          // onRepresentativeChange={this.onRepresentativeChange}
        />
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  errors: state.errors[ADMIN_UPDATE_USER_SAGA],
  errorsFrontend: state.errors[`${ADMIN_UPDATE_USER_SAGA}_FRONTEND`],
  user: state.users.tmp,
});

const mapDispatchToProps = (dispatch) => ({
  loadEditUser: (id) => dispatch(loadEditUser(id)),
  adminUpdateUserSponsor: (user) => dispatch(adminUpdateUserSaga(user)),
  validateUser: (errors) =>
    dispatch(addValidateError(ADMIN_UPDATE_USER_SAGA, errors)),
  cleanErrors: () => dispatch(cleanErrors(ADMIN_UPDATE_USER_SAGA)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditUserSponsor);



// WEBPACK FOOTER //
// ./src/containers/Admin/UserSponsors/EditUserSponsor.jsx